import React, { ReactNode, createContext, useContext } from "react";
import { EditBookingProps } from "./EditBooking";

interface EditBookingContextValue extends EditBookingProps {
  classes: Record<string, string>;
}
interface EditBookingProviderProps extends EditBookingProps {
  children: ReactNode;
  classes: Record<string, string>;
}
const EditBookingContext = createContext<EditBookingContextValue | undefined>(
  undefined
);

const EditBookingContextProvider: React.FC<EditBookingProviderProps> = ({
  children,
  classes,
  isOpen,
  onClose,
  booking,
}) => {
  const contextValue: EditBookingContextValue = {
    classes: classes,
    isOpen: isOpen,
    onClose: onClose,
    booking: booking,
  };
  return (
    <EditBookingContext.Provider value={contextValue}>
      {children}
    </EditBookingContext.Provider>
  );
};

const useEditBookingContext = (): EditBookingContextValue => {
  const context = useContext(EditBookingContext);
  if (!context) {
    throw new Error(
      "useEditBookingContext must be used within an EditBookingContextProvider"
    );
  }
  return context;
};

export { EditBookingContextProvider, useEditBookingContext };
